let moment = require("moment");

class OrderItemInformationEdit {
  constructor(obj = {}) {
    Object.assign(this, obj);
  }

  product = null;
  idDetallePedido = 0;
  denominacion = 0;
  importe = 0;

  direccion = "";
  codigo = "";
  descripcion = "";
  unidad_medida = "";
  moneda = "";

  _cantidad = "";

  get cantidad() {
    let value = Number(this._cantidad);
    value = value || 1;
    value = Math.abs(value);
    value = Math.trunc(value);

    return value;
  }

  set cantidad(value) {
    this._cantidad = value;
  }

  _fechaEntrega = null;
  get fecha_entrega() {
    if (!!this._fechaEntrega) {
      return moment(this._fechaEntrega).format("YYYY-MM-DD");
    }
    return moment().format("YYYY-MM-DD");
  }

  get fecha_entrega_usuario() {
    if (!!this._fechaEntrega) {
      return moment(this._fechaEntrega).format("DD-MM-YYYY");
    }
    return moment().format("YYYY-MM-DD");
  }

  toJSON() {
    return {
      ...this,
      fechaEntrega: this.fecha_entrega,
      cantidad: this.quantity
    };
  }

  get subtotal() {
    if (!!this.product.productoCliente) {
      return this.cantidad * this.product.productoCliente.importe;
    }

    return 0;
  }
}

module.exports = OrderItemInformationEdit;
